import { render } from "./CommentAttacher.vue?vue&type=template&id=35d18fbf"
import script from "./CommentAttacher.vue?vue&type=script&lang=js"
export * from "./CommentAttacher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__